<template>
  <div class="mallManagement">
    <div class="main">
      <div class="lft">
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :unique-opened="true"
          background-color="#FFF"
          text-color="#000"
          active-text-color="#1C6AFF"
          router
        >
          <el-submenu index="1">
            <template slot="title">
              <span>商品</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/apply/mallManagement/mall/manage"
                >商品管理</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/newGoodsSort"
                >商品分类</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/commodityLabel"
                >商品标签</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/commodityServe"
                >商品服务</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/Group"
                >商品分组</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/Brand"
                >商品品牌</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/Attribute"
                >商品属性</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/Parameter"
                >商品参数</el-menu-item
              >
              <el-menu-item index="/apply/mallManagement/mall/comType"
                >商品类型</el-menu-item
              >
             <el-menu-item index="/apply/mallManagement/mall/screen"
                >筛选项管理</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="order">
            <template slot="title">
              <span>订单</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/apply/mallManagement/order/allOrder">全部订单</el-menu-item>
              <el-menu-item index="/apply/mallManagement/order/dfhOrder">待发货</el-menu-item>
              <el-menu-item index="/apply/mallManagement/order/dfkOrder">待付款</el-menu-item>
              <el-menu-item index="/apply/mallManagement/order/ywcOrder">已完成</el-menu-item>
              <el-menu-item index="/apply/mallManagement/order/ygbOrder">已关闭</el-menu-item>
              <el-menu-item index="1-6">售后订单</el-menu-item>
              <el-menu-item index="/apply/mallManagement/order/orderTools">订单工具</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="system">
            <template slot="title">
              <span>系统管理</span>
            </template>
            <el-submenu index="/apply/mallManagement/system/home">
              <template slot="title">首页</template>
              <el-menu-item index="/apply/mallManagement/system/home/advertising">广告</el-menu-item>
              <el-menu-item index="/apply/mallManagement/system/home/navigation">导航</el-menu-item>
            </el-submenu>
            <el-submenu index="/apply/mallManagement/system/shopMall">
              <template slot="title">商城</template>
              <el-menu-item index="/apply/mallManagement/system/shopMall/notice">公告管理</el-menu-item>
              <el-menu-item index="/apply/mallManagement/system/shopMall/comment">评价管理</el-menu-item>
              <el-menu-item index="/apply/mallManagement/system/shopMall/backAddress">退货地址</el-menu-item>
              <el-menu-item index="/apply/mallManagement/system/shopMall/rank">排行榜设置</el-menu-item>
              <el-menu-item index="3-1-2">商城状态</el-menu-item>
              <el-menu-item index="3-1-1">绑定信息设置</el-menu-item>
              <el-menu-item index="3-1-2">消息推送</el-menu-item>
              <el-menu-item index="3-1-7">短信配置</el-menu-item>
            </el-submenu>
            <el-submenu index="/apply/mallManagement/system/distribution">
              <template slot="title">配送方式</template>
              <el-submenu index="/apply/mallManagement/system/distribution/expressage">
                <template slot="title">快递配送</template>
                <el-menu-item
                  index="/apply/mallManagement/system/distribution/expressage/waybill"
                >快递运单</el-menu-item>
                <el-menu-item
                  index="/apply/mallManagement/system/distribution/expressage/freightSet"
                >快递设置</el-menu-item>
              </el-submenu>
              <el-menu-item index="3-1-2">同城配送</el-menu-item>
              <el-menu-item index="3-1-2">自提</el-menu-item>
            </el-submenu>
          </el-submenu>
        </el-menu>
      </div>
      <div class="rgt">
        <div class="rgt-header">
          <div>
            <p v-html="crumbsCont"></p>
          </div>
        </div>
        <div class="cont">
          <transition name="el-fade-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "mallManagement",
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  data() {
    return {
      show: true,
      isCollapse: false
    };
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
    change() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>

<style lang="scss" scoped>
.mallManagement {
  height: 100%;
  position: relative;
  i {
    color: #fff;
  }
  .main {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    .lft {
      height: 100%;
      background: #ffffff;
      overflow: hidden;
      .el-menu {
        border: 0;
      }
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 160px;
        min-height: 400px;
      }
    }
    .rgt {
      flex: 1;
      position: relative;
      .cont {
        position: absolute;
        top: 40px;
        bottom: 0;
        width: 100%;
      }
      .rgt-header {
        height: 40px;
        text-align: left;
        background: #fff;
        // -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
        // box-shadow: 1px 2px 4px rgba(0, 21, 41, 0.08);
        line-height: 40px;
        font-size: 14px;
        padding-left: 24px;
      }
    }
  }
}
</style>

<style lang="scss">
.mallManagement {
  .el-menu-item-group__title {
    padding: 0;
  }
}
</style>
